import { useEnableMapListExperiment } from 'experiments/use-enable-map-list-experiment';
import StoreLocator from 'pages/store-locator';
import StoreLocatorExperiment from 'pages/store-locator-experiment';

export default function StoreLocatorPage() {
  const enableMapListExperiment = useEnableMapListExperiment();

  return enableMapListExperiment ? <StoreLocatorExperiment /> : <StoreLocator />;
}
